/**
 * Text formatting primitives — single source of truth (SSOT).
 * Framework-agnostic (no Nuxt/Vue deps): importable by the SaaS via the
 * `@shared` alias AND by the standalone widget vite build via relative path.
 */

/**
 * Provider raw labels ("CABINE EXTÉRIEURE 4 LITS VUE PARTIELLE",
 * "PENSION COMPLETE 1 ADULTE SELF SERVICE", "FANTASTIC") → sentence case.
 * Only touches strings that are entirely upper-cased: a label already
 * correctly cased ("Cabine intérieure Premium") is returned verbatim.
 */
export function humanizeLabel(raw: string | null | undefined): string {
  if (!raw) return ''
  const s = raw.trim()
  if (s !== s.toUpperCase() || !/\p{Lu}/u.test(s)) return s
  const lower = s.toLowerCase()
  return lower.charAt(0).toUpperCase() + lower.slice(1)
}
